import axios from "axios"
import currencyFormatter from "currency-formatter"
import Cookies from "js-cookie"
import jwt from "jsonwebtoken"
import moment from "moment"
import path from "path"
import { bindActionCreators } from "redux"
// import dotenv from "dotenv"
import accountReducer from "../../redux/reducers/accountReducer"
import baoTriPhuongTien from "../../redux/reducers/bao_tri_reducer"
import calendar_events from "../../redux/reducers/calendar_reducer"
import configCalendar from "../../redux/reducers/config_calendar_reducer"
import fDashboard from "../../redux/reducers/f_dashboard_reducer"
import menu from "../../redux/reducers/menu_reducer"
import systemReducer from "../../redux/reducers/systemReducer"
import transportationReducer from "../../redux/reducers/transportationReducer"
import phuTung from "../../redux/reducers/phu_tung_reducer"
import lopXe from "../../redux/reducers/tire_reducer"
import fuelChange from "../../redux/reducers/fuel_change_reducer"
import normConfiguration from "../../redux/reducers/norm_configuration_reducer"
import fuelChangeReport from "../../redux/reducers/fuel_change_report_reducer"
import generalFuelReport from "../../redux/reducers/general_fuel_report_reducer"
import maintainanceReport from "../../redux/reducers/maintainance_report_reducer"

const hostName = process.env.HOST // http://testv4.adagps.com/
const powerWriteLog = true

const CONSTANTS = {
    API_HOST: `${hostName}index.php`,
    SHORT_DATE_FORMAT: "DD/MM/YYYY",
    DATE_FORMAT: "DD/MM/YYYY, HH:mm:ss",
    FULL_DATE_FORMAT: "dddd, DD-MM-YYYY, HH:mm:ss",
    REG_EXP_NATURAL_NUMBER: /^[0-9\b]+$/,
    KEY: {
        limit_image_size: 10000,
        limit_file_size: 200000
    },
    LOG_SWITCH: {
        power: true
    },
    COMMON: {
        TOKEN: "gut-access-token",
        ACCESS_PARAM: "access-param",
        USER_INFO: "info",
        CURRENT_PATH: "current_path",
        DEFAULT_COUNTRY: "VN",
        DEFAULT_ETHNIC: 25,
        DEFAULT_ACTIVE: 1,
        DEFAULT_DELETE: 0,
        DATE_FORMAT: "dd/mm/yyyy"
    },
    CODE: {
        CODE_200: 200,
        CODE_299: 299,
        CODE_404: 404,
        CODE_500: 500,
        NOT_ALLOW: "not_allow",
        ID_REQUIRE: "id_require",
        AUTHST_SUCCESSFUL: "authst_successful",
        POST_UNSUCCESSFUL: "post_unsuccessful",
        LIMIT_LOGIN: "limit_login",
        WRONG_USERNAME: "wrong_username",
        WRONG_PASSWORD: "wrong_password",
        TOKEN_EXPIRED: "token_expired",
        TOKEN_VALID: "token_valid",
        TOKEN_INVALID: "token_invalid",
        CREATE_SUCCESSFUL: "create_successful",
        CREATE_UNSUCCESSFUL: "create_unsuccessful",
        UPDATE_SUCCESSFUL: "update_successful",
        UPDATE_UNSUCCESSFUL: "update_unsuccessful",
        DELETE_SUCCESSFUL: "delete_successful",
        POST_SUCCESSFUL: "post_successful",
        ACCOUNT_VALID: "account_valid",
        ACCOUNT_INVALID: "account_invalid",
        DOCUMENT_INVALID: "document_invalid",
        EXISTED_USERNAME: "existed_username",
        EXISTED_EMAIL: "existed_email",
        EXISTED_PHONE: "existed_phone",
        USERNAME_EMAIL_NOT_EXISTED_ON_ACCOUNT:
            "username_email_not_existed_on_account",
        RESEND_PASSWORD_SUCCESSFUL: "resend_password_successful",
        IS_UPDATE: "is_update",
        IS_NOT_UPDATE: "is_not_update",
        IS_NOT_UPDATE_OR_UPDATED: "is_not_update_or_updated",
        URL_VALID: "url_valid",
        URL_INVALID: "url_invalid",
        LOGIN_SUCCESSFUL: "login_successful",
        PRIMARY_ACCOUNT: "primary_account",
        SECONDARY_ACCOUNT: "secondary_account",
        PRIMARY_STORE: "primary_store",
        SECONDARY_STORE: "secondary_store",
        LOCKED_ACCOUNT: "locked_account"
    },
    URL: {
        AVATAR: `${hostName}/assets/uploads/avatar/`,
        IMAGE_UPLOAD: hostName,
        AUTH: {
            GET_TOKEN: "/api/LoginController/loginAction",
            TRANSFER_USER: "/api/AuthController/tranferredUser"
        },
        ACCOUNT: {
            GET: "/api/AuthController/getInfoUserLogin",
            GET_USERS_TRANSFERANCE: "/api/AuthController/getListUserTransfer"
        },
        TRANSPORTATION: {
            GET_ALL: "/api/PublicController/getVehicles",
            GET_BY_TYPE: "/api/PublicController/getVehiclesByCarType",
            GET_BY_ID: "/api/PublicController/detailVehicle",
            GET_DETAIL_TRANSPORTANTION: "/api/PublicController/detailVehicle",
            GET_INFO_TRANSPORTANTION: "/api/PublicController/getVehicleInfo",
            GET_TYPE_TRANSPORTATION:
                "/api/PublicController/getListLoaiPhuongTien",
            GET_FUEL_TRANSPORTANTION:
                "/api/PublicController/getListLoaiNhienLieu",
            GET_BUSSINESS_TRANSPORTANTION:
                "/api/PublicController/getListHinhThucKDVT",
            // GET_CAR_BADGES: "/api/TabHoSoGiayToController/get_hosogiayto_phuhieu",edi
            UPDATE_INFOMATION_TRANSPORTATION:
                "/api/PublicController/updateVehicleInfo",
            POST_INFOMATION_TRANSPORTATION: "chua cap nhat url",
            DELETE_TRANSPORTATION: "/api/PublicController/deleteVehicle"
        },
        REGISTRATION_PAPER: {
            GET_ALL: "/api/TabHoSoGiayToController/getHSGTDangKiem",
            GET_BY_ID: "/api/TabHoSoGiayToController/viewDetailDangKiem",
            POST: "/api/TabHoSoGiayToController/insertDangKiem",
            PUT: "/api/TabHoSoGiayToController/updateDangKiem",
            DELETE: "/api/TabHoSoGiayToController/deleteDangKiem",
            UPLOAD_FILE: "/api/TabHoSoGiayToController/uploadTmpFileDangKiem",
            UPLOAD_FILE_ID:
                "/api/TabHoSoGiayToController/uploadTmpFileDangKiemId"
        },
        TYPE_TRANSPORTATION: {
            GET_ALL: "/api/PublicController/get_list_loai_phuongtien"
        },
        TYPE_TRANSPORTATION_ROAD_FEE: {
            GET_ALL:
                "/api/TabHoSoGiayToController/get_list_loaiphuongtien_phiduongbo",
            GET_BY_TYPE:
                "/api/TabHoSoGiayToController/get_list_phiduongbo_theo_loaiphuongtien"
        },
        FORM_TRANSPORTATION: {
            GET_ALL: "/api/PublicController/get_list_hinhthuc_kinhdoanhvt"
        },
        TYPE_FUEL_TRANSPORTATION: {
            GET_ALL: "/api/PublicController/getListLoaiNhienLieu"
        },
        REGISTRATION_CENTER_PROVIDER: {
            GET_ALL: "/api/TabHoSoGiayToController/getDSTrungTamDangKiem"
        },
        INSURANCE_CENTER_PROVIDER: {
            GET_ALL: "/api/TabHoSoGiayToController/getDSCungCapBaoHiem"
        },
        CAR_BADGES_CENTER_PROVIDER: {
            GET_ALL: "/api/TabHoSoGiayToController/getDSCungCapPhuHieu"
        },
        CAR_BADGES_TYPE: {
            GET_ALL: "/api/TabHoSoGiayToController/getDSLoaiPhuHieu"
        },
        REGISTRATION_CARD_CENTER_PROVIDER: {
            GET_ALL: "/api/TabHoSoGiayToController/getDSCungCapDangKy"
        },
        FACTORY_TRANSPORTATION: {
            GET_ALL: "/api/PublicController/getDSHangXe"
        },
        MEMBER: {
            GET_ALL: "/api/UserController/getListThanhVien"
        },
        INSURANCE_PAPER: {
            GET_ALL: "/api/TabHoSoGiayToController/getHSGTBaoHiem",
            GET_BY_ID: "/api/TabHoSoGiayToController/viewDetailBaoHiem",
            POST: "/api/TabHoSoGiayToController/insertBaoHiem",
            PUT: "/api/TabHoSoGiayToController/updateBaoHiem",
            DELETE: "/api/TabHoSoGiayToController/deleteBaoHiem",
            UPLOAD_FILE: "/api/TabHoSoGiayToController/uploadTmpFileBaoHiem"
        },
        CAR_BADGES_PAPER: {
            GET_ALL: "/api/TabHoSoGiayToController/getHSGTPhuHieu",
            GET_BY_ID: "/api/TabHoSoGiayToController/viewDetailPhuHieu",
            POST: "/api/TabHoSoGiayToController/insertPhuHieu",
            PUT: "/api/TabHoSoGiayToController/updatePhuHieu",
            DELETE: "/api/TabHoSoGiayToController/deletePhuHieu",
            UPLOAD_FILE: "/api/TabHoSoGiayToController/uploadTmpFilePhuHieu"
        },
        ROAD_FEE: {
            GET_ALL: "/api/TabHoSoGiayToController/getHSGTPhiDuongBo",
            GET_BY_ID: "/api/TabHoSoGiayToController/viewDetailPhiDuongBo",
            POST: "/api/TabHoSoGiayToController/insertPhiduongbo",
            PUT: "/api/TabHoSoGiayToController/updatePhiduongbo",
            DELETE: "/api/TabHoSoGiayToController/deletePhiduongbo",
            UPLOAD_FILE: "/api/TabHoSoGiayToController/uploadTmpFilePhiduongbo"
        },
        REGISTRATION_CARD_PAPER: {
            GET_ALL: "/api/TabHoSoGiayToController/getHSGTDangKy",
            GET_BY_ID: "/api/TabHoSoGiayToController/viewDetailDangKy",
            POST: "/api/TabHoSoGiayToController/insertDangKy",
            PUT: "/api/TabHoSoGiayToController/updateDangKy",
            DELETE: "/api/TabHoSoGiayToController/deleteDangKy",
            UPLOAD_FILE: "/api/TabHoSoGiayToController/uploadTmpFileDangKy"
        },
        MAINTENANCE_TRANSPORTATION: {
            GET_ALL: "/api/TabBaoTriBaoDuongController/getDSBaoTriBaoDuong",
            GET_BY_ID: "/api/TabBaoTriBaoDuongController/viewDetailBaoDuong"
        },
        INCIDENT_TRANSPORTATION: {
            GET_ALL: "/api/TabSuCoController/getDSSuCo",
            GET_BY_ID: "/api/TabSuCoController/viewSuCo",
            POST: "/api/TabSuCoController/addSuCo",
            PUT: "/api/TabSuCoController/updateSuCo",
            DELETE: "/api/TabSuCoController/confirmSuCo",
            UPLOAD_FILE: "/api/TabSuCoController/uploadTmpFileSuCo"
        },
        TODO_INCIDENT_TRANSPORTATION: {
            GET_ALL: "/api/TabSuCoController/getDSTodoCanAddSuCo"
        },
        COST_TRANSPORTATION: {
            GET_ALL: "/api/TabFeeController/getFeeOfVehicle",
            GET_BY_ID: "/api/TabFeeController/getDetailFee",
            POST: "/api/TabFeeController/addFee",
            PUT: "/api/TabFeeController/updateFee",
            DELETE: "/api/TabFeeController/deleteFee",
            UPLOAD_FILE: "/api/TabFeeController/uploadTmpFileFee"
        },
        CALENDAR_REMINDER_TRANSPORTATION: {
            GET_ALL: "/api/TabLichNhacController/getDSLichNhac",
            GET_BY_ID: "/api/TabLichNhacController/viewLichNhac",
            GET_USERS: "/api/TabLichNhacController/getDSUser",
            GET_MAINTANANCE_PROVIDER:
                "/api/TabLichNhacController/getDSCungCapDichVu",
            POST: "chuacapnhat",
            PUT: "/api/TabLichNhacController/saveLichBaoDuongXe",
            DELETE: "/api/TabLichNhacController/cancelLichNhac"
        },
        CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION: {
            GET_BY_ID:
                "/api/TabBaoTriBaoDuongController/getLichBaoDuongTheoHang",
            POST: "/api/TabBaoTriBaoDuongController/ActionLichBaoDuongHang",
            CHECK_EXISTED_CALENDAR_MAINTANANCE_CONFIG:
                "/api/TabBaoTriBaoDuongController/checkCHBaoDuongXe",
            // lấy km bắt đầu, km hiện tại theo ngày được chọn
            GET_KM_BEGIN_END:
                "/api/TabBaoTriBaoDuongController/getKmGPSByDateApply"
        },
        BAO_TRI_PHUONG_TIEN: {
            GET_BAO_TRI_PHUONG_TIEN:
                "/api/TabBaoTriBaoDuongController/getDSBaoTriBaoDuong",
            POST_BAO_TRI_PHUONG_TIEN:
                "/api/TabBaoTriBaoDuongController/insertViecBaotri",
            PUT_BAO_TRI_PHUONG_TIEN:
                "/api/TabBaoTriBaoDuongController/updateViecBaotri",
            DELETE_BAO_TRI_PHUONG_TIEN:
                "/api/TabBaoTriBaoDuongController/deleteViecBaotri"
        },
        CALENDAR_REMINDER_CONFIG_TRANSPORTATION: {
            GET_REMINDER_DOCUMENT_CONFIG:
                "/api/TabLichNhacController/getAlarmHSGT",
            PUT_REMINDER_DOCUMENT_CONFIG:
                "/api/TabLichNhacController/updateAlarmHSGT",
            GET_REMINDER_MAINTANANCE_CONFIG:
                "/api/TabLichNhacController/getAlarmBaoDuong",
            PUT_REMINDER_MAINTANANCE_CONFIG:
                "/api/TabLichNhacController/updateAlarmBaoDuong"
        },
        TODO_CALENDAR_REMINDER_TRANSPORTATION: {
            GET_ALL: "/api/TabLichNhacController/getDSTodoCanAddBaoDuongXe",
            GET_ALL_NO_ID:
                "/api/TabBaoTriBaoDuongController/getALLDSViecBaoDuong"
        },
        TODO_LIST: {
            GET_ALL: "/api/DanhMucController/getDSViec",
            GET_DS_VIEC_FULL: "/api/DanhMucController/getDSViecFull",
            GET_BY_ID: "/api/DanhMucController/viewDetailViec",
            POST: "/api/DanhMucController/addViec",
            PUT: "/api/DanhMucController/editViec",
            DELETE: "/api/DanhMucController/deleteViec"
        },
        DANH_MUC_BAO_DUONG: {
            GET_ALL: "/api/DanhMucController/getDSNhaCungCapBDPT",
            GET_DS_FULL: "/api/DanhMucController/getDSNhaCungCapBDPTFull",
            GET_BY_ID: "/api/DanhMucController/viewNhaCungCapBDPT",
            POST: "/api/DanhMucController/addDSNhaCungCapBDPT",
            PUT: "/api/DanhMucController/editNhaCungCapBDPT",
            DELETE: "/api/DanhMucController/deleteNhaCungCapBDPT"
        },
        DANH_SACH_TRUNG_TAM_DANG_KIEM: {
            GET_ALL: "/api/DanhMucController/getDSDonViCungCapHoSo",
            GET_BY_ID: "/api/DanhMucController/viewDVCungCapHoSo",
            POST: "/api/DanhMucController/addDVCungCapHoSo",
            PUT: "/api/DanhMucController/editDVCungCapHoSo",
            DELETE: "/api/DanhMucController/deleteDVCungCapHoSo"
        },
        DANH_SACH_NHA_CUNG_CAP_BAO_HIEM: {
            GET_ALL: "/api/DanhMucController/getDSDonViCungCapHoSo",
            GET_BY_ID: "/api/DanhMucController/viewDVCungCapHoSo",
            POST: "/api/DanhMucController/addDVCungCapHoSo",
            PUT: "/api/DanhMucController/editDVCungCapHoSo",
            DELETE: "/api/DanhMucController/deleteDVCungCapHoSo"
        },
        DANH_SACH_NHA_CUNG_CAP_PHU_HIEU: {
            GET_ALL: "/api/DanhMucController/getDSDonViCungCapHoSo",
            GET_BY_ID: "/api/DanhMucController/viewDVCungCapHoSo",
            POST: "/api/DanhMucController/addDVCungCapHoSo",
            PUT: "/api/DanhMucController/editDVCungCapHoSo",
            DELETE: "/api/DanhMucController/deleteDVCungCapHoSo"
        },
        DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE: {
            GET_ALL: "/api/DanhMucController/getDSDonViCungCapHoSo",
            GET_BY_ID: "/api/DanhMucController/viewDVCungCapHoSo",
            POST: "/api/DanhMucController/addDVCungCapHoSo",
            PUT: "/api/DanhMucController/editDVCungCapHoSo",
            DELETE: "/api/DanhMucController/deleteDVCungCapHoSo"
        },
        DANH_SACH_TINH_THANH: {
            GET_ALL: "/api/DanhMucController/getDSTinhThanh"
        },
        DANH_MUC_TINH_THANH: {
            GET_ALL: "/api/DanhMucController/getDSTinhThanh",
            GET_BY_ID: "",
            POST: "",
            PUT: "",
            DELETE: ""
        },
        DANH_MUC_HO_SO_GIAY_TO: {
            GET_ALL: "",
            GET_BY_ID: "",
            POST: "",
            PUT: "",
            DELETE: ""
        },
        TYPE_OF_FEE_TRANSPORTATION: {
            GET_ALL: "/api/TabFeeController/getListFee"
        },
        DRIVERS_TRANSPORTATION: {
            // GET_ALL: "/api/TabFeeController/getListDriver",
            GET_ALL: "/api/DriverController/getDriverList",
            GET_BY_ID: "/api/DriverController/getExtendDataByDriverID",
            POST_DANH_SACH_TAI_XE_LIST:
                "/api/DriverController/saveExtendDataForDriver",
            PUT: "/api/DriverController/saveExtendDataForDriver",
            DELETE: "/api/DriverController/saveExtendDataForDriver"
        },
        F_DASHBOARD: {
            STATISTICAL_TRANSPORTATION:
                "/api/DanhMucController/getCountVehicle",
            STATISTICAL_REMINDER: "/api/DanhMucController/checkCountAlarm",
            ACTIVITY_TRANSPORTATION: "/api/DanhMucController/getListActivity",
            GRAPH_PRICE_ACTIVITY_TRANSPORTATION:
                "/api/DanhMucController/getDataChartForVehicle",
            GRAPH_PRICE_TIME_TRANSPORTATION:
                "/api/DanhMucController/getDataChart",
            GRAPH_ACTIVITY_TRANSPORTATION:
                "/api/DanhMucController/getChartTimeForVehicle"
        },
        REPORT: {
            REPORT_FEE_TRANSPORTATION: "/api/DanhMucController/reportFeeVehicle"
        },
        CALENDAR: {
            GET_ALL_CALENDAR_BY_TIME:
                "/api/TabLichNhacController/getDSLichNhac_theothoigian"
        },
        FORM_LIST: {
            GET_ALL: "/api/TabSuCoController/getListOptionTodo",
            GET_BY_ID: "",
            POST: "",
            PUT: "",
            DELETE: ""
        },
        IMAGE: {
            POST: "/image/upload",
            DELETE: "/image/upload"
        },
        FILE: {
            POST_REGISTER_PAPER:
                "/api/TabHoSoGiayToController/upload_tmp_anh_dangkiem",
            DELETE: "/image/upload"
        },
        PHU_TUNG: {
            GET_TYPE_PHU_TUNG:
                "/api/SparePartController/getSparePartsTypeList?",
            GET_LIST_PHU_TUNG: "/api/SparePartController/getSparePartsList?",
            GET_LIST_PHU_TUNG_BY_ID: "/api/SparePartController/getSparePartsList?start=0",
            POST_PHU_TUNG: "/api/SparePartController/insertSpareParts?",
            PUT_PHU_TUNG: "/api/SparePartController/updateSpareParts?",
            DELETE_PHU_TUNG: "/api/SparePartController/deleteSpareParts?"
        },
        TIRE: {
            GET_LIST_PHUONGTIEN:
                "/api/VehicleTiresSettingController/getVehiclesList?",
            GET_LIST_PHUTUNG:
                "/api/VehicleTiresSettingController/getSparePartsList",
            POST_PT_TIRE:
                "/api/VehicleTiresSettingController/saveAction?form_mode=0",
            PUT_PT_TIRE:
                "/api/VehicleTiresSettingController/saveAction?form_mode=1",
            DELETE_PT_TIRE: "/api/VehicleTiresSettingController/deleteAction?",
            POST_REPORT_BYTIME:
                "/api/VehicleTiresSettingController/searchAction?start=0"
        },
        FUEL_CHANGE: {
            GET_VEHICLES_LIST:
                "/api/FuelExtendedChangeController/getVehiclesList",
            GET_FUEL_TYPE_LIST:
                "/api/FuelExtendedChangeController/getFuelTypeList",
            GET_LOCATION_LIST:
                "/api/FuelExtendedChangeController/getLocationList",
            GET_DRIVER_LIST: "/api/FuelExtendedChangeController/getDriverList					",
            POST_SEARCH_ACTION:
                "/api/FuelExtendedChangeController/searchAction",
            POST_INSERT_FUEL_CHANGE:
                "/api/FuelExtendedChangeController/insertFuelChange",
            POST_UPDATE_FUEL_CHANGE:
                "/api/FuelExtendedChangeController/updateFuelChange",
            GET_DELETE_FUEL_CHANGE:
                "/api/FuelExtendedChangeController/deleteFuelChange",
            GET_VIEW_DETAIL_ACTION:
                "/api/FuelExtendedChangeController/viewDetailAction",
            POST_UPLOAD_TMP_FILE_FUEL:
                "/api/FuelExtendedChangeController/uploadTmpFileFuel"
        },
        NORM_CONFIGURATION: {
            GET_VEHICLE_GROUPS:
                "/api/VehicleExtendedSettingController/getVehicleGroups",
            POST_VEHICLE_LIST:
                "/api/VehicleExtendedSettingController/getVehicleList",
            GET_VEHICLE_SETTINGS:
                "/api/VehicleExtendedSettingController/loadSettingForVehicle",
            POST_SAVE_ACTION:
                "/api/VehicleExtendedSettingController/saveAction",
            GET_DELETE_ACTION:
                "/api/VehicleExtendedSettingController/deleteAction"
        },
        FUEL_CHANGE_REPORT: {
            POST_VEHICLE_LIST:
                "/api/FuelExtendedChangeController/getVehiclesList",
            POST_REPORT_DATA_ACTION:
                "/api/FuelExtendedChangeController/getReportDataAction",
            POST_DOWNLOAD_REPORT_ACTION:
                "/api/FuelExtendedChangeController/exportAction?export_type="
        },
        GENERAL_FUEL_REPORT: {
            GET_VEHICLE_GROUPS: "/api/VehicleExtendedSettingController/getVehicleGroups",
            POST_VEHICLES_BY_GROUP: "/api/FuelExtendedChangeController/getVehiclesByGroup",
            POST_REPORT_EXTEND_DATA_ACTION: "/api/FuelExtendedChangeController/getReportDataExtend",
            POST_DOWNLOAD_EXTEND_REPORT_ACTION: "/api/FuelExtendedChangeController/exportExtendAction?export_type="
        },
        MAINTAINANCE_REPORT: {
            POST_VEHICLE_LIST: "/api/VehicleExtendedSettingController/getVehicleList",
            GET_MAINTAINANCE_WORKS: "/api/DanhMucController/getDSViecFull",
            GET_VENDOR_SUPPLIES: "/api/DanhMucController/getDSNhaCungCapBDPTFull",
            POST_REPORT_DATA_ACTION: "/api/TabBaoTriBaoDuongController/getDSBaoTriTheoKhachHang",
            POST_DOWNLOAD_REPORT_ACTION: "/api/TabBaoTriBaoDuongController/exportDSBaoTriTheoKhachHang",
        }
    },
    REDUCERS: {
        system: systemReducer,
        account: accountReducer,
        transportations: transportationReducer,
        configCalendar: configCalendar,
        menu: menu,
        fDashboard: fDashboard,
        baoTriPhuongTien: baoTriPhuongTien,
        calendar_events: calendar_events,
        phuTung: phuTung,
        lopXe: lopXe,
        fuelChange: fuelChange,
        normConfiguration: normConfiguration,
        fuelChangeReport: fuelChangeReport,
        generalFuelReport: generalFuelReport,
        maintainanceReport: maintainanceReport
    },
    ACTION: {
        SYSTEM: {
            ON_RESIZE: "on_resize",
            SET_HEIGHT_DASHBOARD: "set_height_dashboard",
            NONE: "none",
            ERROR: "error",
            CODE_200: "code_200",
            CODE_299: "code_299",
            CODE_404: "code_404",
            CODE_500: "code_500",
            NOT_ALLOW: "not_allow",
            TOKEN_INVALID: "token_invalid",
            DOCUMENT_INVALID: "document_invalid",
            SCROLL_TOP: "scroll_top",
            SET_LANGUAGE: "set_language",
            AUTHORIZATION: "authorization",
            STATUS: "status",
            IS_SHOW_LOADING: "is_show_loading",
            IS_HIDE_LOADING: "is_hide_loading",
            IS_SHOW_FDASHBOARD: "is_show_fdashboard",
            REPORT_FEE_TRANSPORTATION: "report_fee_transportation",
            UPDATE_REPORT_FEE_TRANSPORTATION:
                "update_report_fee_transportation",
            SHOW_DASHBOARD: "show_dashboard",
            HIDE_DASHBOARD: "hide_dashboard",
            SHOW_MESSAGE: "show_message",
            HIDE_MESSAGE: "hide_message",
            REQUIRE_LOGIN_CREATE_STORE: "require_login_create_store",
            UPDATE_APPLICATION_VIEW: "update_application_view",
            IS_SHOW_MODAL: "is_show_modal",
            HIDE_MODAL: "hide_modal",
            HANDLE_DELETE_FIELD_EDIT_MODAL: "handle_delete_field_edit_modal",
            IS_SHOW_EDITOR: "is_show_editor",
            IS_SHOW_EDITOR_COMMENT: "is_show_editor_comment",
            ON_CLOSE_EDITOR: "on_close_editor",
            ON_SAVE_EDITOR: "on_save_editor",
            ON_SAVE_COMMENT: "on_save_comment",
            ON_CHANGE_EDITOR: "on_change_editor",
            ON_IMAGE_UPLOAD_EDITOR: "on_image_upload_editor",
            CLEAR_EDITOR: "clear_editor",
            CLEAR_ALL_EDITOR: "clear_all_editor",
            UPDATE_MENTIONS: "update_mentions",
            SET_MENTIONS: "set_mentions",
            SHOW_CONFIRM_MODAL: "show_confirm_modal",
            HIDE_CONFIRM_MODAL: "hide_confirm_modal"
        },
        ACCOUNT: {
            HANDLE_CHANGE_ACCOUNT: "handle_change_account",
            SET_ACCOUNT: "set_account",
            UPDATE_ACCOUNT: "update_account",
            DELETE_ACCOUNT: "delete_account",
            GET_USERS_TRANSFERANCE: "get_users_transferance",
            TRANSFER_USER: "transfer_user"
        },
        F_DASHBOARD: {
            STATISTICAL_TRANSPORTATION: "statistical_transportation",
            STATISTICAL_REMINDER: "statistical_reminder",
            STATISTICAL_REMINDER_BY_TIME: "statistical_reminder_by_time",
            ACTIVITY_TRANSPORTATION: "activity_transportation",
            GRAPH_PRICE_ACTIVITY_TRANSPORTATION:
                "graph_price_activity_transportation",
            GRAPH_PRICE_ACTIVITY_TRANSPORTATION_BY_PARAMS:
                "graph_price_activity_transportation_by_params",
            GRAPH_PRICE_TIME_TRANSPORTATION: "graph_price_time_transportation",
            GRAPH_PRICE_TIME_TRANSPORTATION_BY_TIME:
                "graph_price_time_transportation_by_time",
            GRAPH_ACTIVITY_TRANSPORTATION: "graph_activity_transportation",
            GRAPH_ACTIVITY_TRANSPORTATION_BY_PARAMS:
                "graph_activity_transportation_by_params"
        },
        TRANSPORTATION: {
            GET_ALL_TRANSPORTATION_OF_ACCOUNT:
                "get_all_transportation_of_account",
            UPDATE_TRANSPORTATIONS: "update_transportations",
            SEARCH: "search",
            SEARCH_BY_TYPE: "search_by_type",
            SET_CURRENT_TRANSPORTATION: "set_current_transportation",
            UPDATE_ROW_CURRENT_TRANSPORTATION:
                "update_row_current_transportation",
            UPDATE_CURRENT_TRANSPORTATION: "update_current_transportation",
            GET_TRANSPORTATION_INSURANCE_PAPER:
                "get_transportation_insurance_paper",
            GET_CAR_BADGES: "get_car_badges",
            UPDATE_TRANSPORTATION_INFOMATION:
                "update_transportation_infomation",
            DELETE_TRANSPORTATION: "delete_transportation",
            POST_TRANSPORTATION_INFOMATION: "post_transportation_infomation",
            UPDATE_CURRENT_TRANSPORTATION_WITH_TYPE:
                "update_current_transportation_with_type"
        },
        TYPE_TRANSPORTATION: {
            GET_TYPE_TRANSPORTATION: "get_type_transportantion",
            SET_TYPE_TRANSPORTATION: "set_type_transportantion"
        },
        FORM_TRANSPORTATION: {
            GET_FORM_TRANSPORTATION: "get_form_transportantion",
            SET_FORM_TRANSPORTANTION: "set_form_transportantion"
        },
        TYPE_FUEL_TRANSPORTATION: {
            GET_TYPE_FUEL_TRANSPORTATION: "get_type_fuel_transportantion",
            SET_TYPE_FUEL_TRANSPORTANTION: "set_type_fuel_transportantion"
        },
        REGISTRATION_PAPER: {
            SET_REGISTRATION_PAPER: "set_registration_paper",
            GET_REGISTRATION_PAPER_BY_ID: "get_registration_paper_by_id",
            GET_REGISTRATION_PAPER: "get_registration_paper",
            ADD_REGISTRATION_PAPER: "add_registration_paper",
            UPDATE_REGISTRATION_PAPER: "update_registration_paper",
            DELETE_REGISTRATION_PAPER: "delete_registration_paper"
        },
        ROAD_FEE: {
            SET_ROAD_FEE: "set_road_fee",
            GET_ROAD_FEE_BY_ID: "get_road_fee_by_id",
            GET_ROAD_FEE: "get_road_fee",
            ADD_ROAD_FEE: "add_road_fee",
            UPDATE_ROAD_FEE: "update_road_fee",
            DELETE_ROAD_FEE: "delete_road_fee"
        },
        REGISTRATION_CENTER_PROVIDER: {
            SET_REGISTRATION_CENTER_PROVIDER:
                "set_registration_center_provider",
            GET_REGISTRATION_CENTER_PROVIDER:
                "get_registration_center_provider",
            UPDATE_REGISTRATION_CENTER_PROVIDER:
                "update_registration_center_provider",
            DELETE_REGISTRATION_CENTER_PROVIDER:
                "delete_registration_center_provider"
        },
        FACTORY_TRANSPORTATION: {
            SET_FACTORY_TRANSPORTATION: "set_factory_transportation",
            GET_FACTORY_TRANSPORTATION: "get_factory_transportation",
            UPDATE_FACTORY_TRANSPORTATION: "update_factory_transportation",
            DELETE_FACTORY_TRANSPORTATION: "delete_factory_transportation"
        },
        INSURANCE_CENTER_PROVIDER: {
            SET_INSURANCE_CENTER_PROVIDER: "set_insurance_center_provider",
            GET_INSURANCE_CENTER_PROVIDER: "get_insurance_center_provider",
            UPDATE_INSURANCE_CENTER_PROVIDER:
                "update_insurance_center_provider",
            DELETE_INSURANCE_CENTER_PROVIDER: "delete_insurance_center_provider"
        },
        CAR_BADGES_CENTER_PROVIDER: {
            SET_CAR_BADGES_CENTER_PROVIDER: "set_car_badges_center_provider",
            GET_CAR_BADGES_CENTER_PROVIDER: "get_car_badges_center_provider",
            UPDATE_CAR_BADGES_CENTER_PROVIDER:
                "update_car_badges_center_provider",
            DELETE_CAR_BADGES_CENTER_PROVIDER:
                "delete_car_badges_center_provider"
        },
        CAR_BADGES_TYPE: {
            SET_CAR_BADGES_TYPE: "set_car_badges_type",
            GET_CAR_BADGES_TYPE: "get_car_badges_type",
            UPDATE_CAR_BADGES_TYPE: "update_car_badges_type",
            DELETE_CAR_BADGES_TYPE: "delete_car_badges_type"
        },
        REGISTRATION_CARD_CENTER_PROVIDER: {
            SET_REGISTRATION_CARD_CENTER_PROVIDER:
                "set_registration_card_center_provider",
            GET_REGISTRATION_CARD_CENTER_PROVIDER:
                "get_registration_card_center_provider",
            UPDATE_REGISTRATION_CARD_CENTER_PROVIDER:
                "update_registration_card_center_provider",
            DELETE_REGISTRATION_CARD_CENTER_PROVIDER:
                "delete_registration_card_center_provider"
        },
        MEMBER: {
            SET_MEMBER: "set_member",
            GET_MEMBER: "get_member",
            UPDATE_MEMBER: "update_member",
            DELETE_MEMBER: "delete_member"
        },
        INSURANCE_PAPER: {
            GET_INSURANCE_PAPER: "get_insurance_paper",
            GET_INSURANCE_PAPER_BY_ID: "get_insurance_paper_by_id",
            ADD_INSURANCE_PAPER: "add_insurance_paper",
            UPDATE_INSURANCE_PAPER: "update_insurance_paper",
            DELETE_INSURANCE_PAPER: "delete_insurance_paper"
        },
        CAR_BADGES_PAPER: {
            GET_CAR_BADGES_PAPER: "get_car_badges_paper",
            GET_CAR_BADGES_PAPER_BY_ID: "get_car_badges_paper_by_id",
            ADD_CAR_BADGES_PAPER: "add_car_badges_paper",
            UPDATE_CAR_BADGES_PAPER: "update_car_badges_paper",
            DELETE_CAR_BADGES_PAPER: "delete_car_badges_paper"
        },
        REGISTRATION_CARD_PAPER: {
            GET_REGISTRATION_CARD_PAPER: "get_registration_card_paper",
            GET_REGISTRATION_CARD_PAPER_BY_ID:
                "get_registration_card_paper_by_id",
            ADD_REGISTRATION_CARD_PAPER: "add_registration_card_paper",
            UPDATE_REGISTRATION_CARD_PAPER: "update_registration_card_paper",
            DELETE_REGISTRATION_CARD_PAPER: "delete_registration_card_paper"
        },
        MAINTENANCE_TRANSPORTATION: {
            GET_MAINTENANCE_TRANSPORTATION: "get_maintenance_transportation",
            GET_MAINTENANCE_TRANSPORTATION_BY_ID:
                "get_maintenance_transportation_by_id",
            ADD_MAINTENANCE_TRANSPORTATION: "add_maintenance_transportation",
            UPDATE_MAINTENANCE_TRANSPORTATION:
                "update_maintenance_transportation",
            DELETE_MAINTENANCE_TRANSPORTATION:
                "delete_maintenance_transportation"
        },
        BAO_TRI_PHUONG_TIEN: {
            GET_BAO_TRI_PHUONG_TIEN_BY_NCC: "get_bao_tri_phuong_tien_by_ncc",
            SET_BAO_TRI_PHUONG_TIEN_BY_NCC: "set_bao_tri_phuong_tien_by_ncc",
            GET_BAO_TRI_PHUONG_TIEN_BY_DS_VIEC:
                "get_bao_tri_phuong_tien_by_ds_viec",
            SET_BAO_TRI_PHUONG_TIEN_BY_DS_VIEC:
                "set_bao_tri_phuong_tien_by_ds_viec",
            GET_BAO_TRI_PHUONG_TIEN_BY_ID: "get_bao_tri_phuong_tien_by_id",
            SET_BAO_TRI_PHUONG_TIEN_BY_ID: "set_bao_tri_phuong_tien_by_id",
            POST_BAO_TRI_PHUONG_TIEN: "post_bao_tri_phuong_tien",
            PUT_BAO_TRI_PHUONG_TIEN: "put_bao_tri_phuong_tien",
            DELETE_BAO_TRI_PHUONG_TIEN: "delete_bao_tri_phuong_tien"
        },
        INCIDENT_TRANSPORTATION: {
            GET_INCIDENT_TRANSPORTATION: "get_incident_transportation",
            GET_INCIDENT_TRANSPORTATION_BY_ID:
                "get_incident_transportation_by_id",
            ADD_INCIDENT_TRANSPORTATION: "add_incident_transportation",
            UPDATE_INCIDENT_TRANSPORTATION: "update_incident_transportation",
            DELETE_INCIDENT_TRANSPORTATION: "delete_incident_transportation"
        },
        TODO_INCIDENT_TRANSPORTATION: {
            GET_TODO_INCIDENT_TRANSPORTATION:
                "get_todo_incident_transportation",
            GET_TODO_INCIDENT_TRANSPORTATION_BY_ID:
                "get_todo_incident_transportation_by_id",
            ADD_TODO_INCIDENT_TRANSPORTATION:
                "add_todo_incident_transportation",
            UPDATE_TODO_INCIDENT_TRANSPORTATION:
                "update_todo_incident_transportation",
            DELETE_TODO_INCIDENT_TRANSPORTATION:
                "delete_todo_incident_transportation"
        },
        CALENDAR_REMINDER_TRANSPORTATION: {
            GET_CALENDAR_REMINDER_TRANSPORTATION:
                "get_calendar_reminder_transportation",
            GET_CALENDAR_REMINDER_TRANSPORTATION_BY_ID:
                "get_calendar_reminder_transportation_by_id",
            GET_USERS_AND_MAINTENANCE_CENTER_PROVIDER_CALENDAR_REMINDER_TRANSPORTATION:
                "get_users_and_maintenance_center_provider_calendar_reminder_transportation",
            ADD_CALENDAR_REMINDER_TRANSPORTATION:
                "add_calendar_reminder_transportation",
            UPDATE_CALENDAR_REMINDER_TRANSPORTATION:
                "update_calendar_reminder_transportation",
            DELETE_CALENDAR_REMINDER_TRANSPORTATION:
                "delete_calendar_reminder_transportation"
        },
        COST_TRANSPORTATION: {
            GET_COST_TRANSPORTATION: "get_cost_transportation",
            GET_COST_TRANSPORTATION_BY_ID: "get_cost_transportation_by_id",
            ADD_COST_TRANSPORTATION: "add_cost_transportation",
            UPDATE_COST_TRANSPORTATION: "update_cost_transportation",
            DELETE_COST_TRANSPORTATION: "delete_cost_transportation"
        },
        TODO_CALENDAR_REMINDER_TRANSPORTATION: {
            GET_TODO_CALENDAR_REMINDER_TRANSPORTATION:
                "get_todo_calendar_reminder_transportation",
            GET_TODO_CALENDAR_REMINDER_TRANSPORTATION_BY_ID:
                "get_todo_calendar_reminder_transportation_by_id",
            ADD_TODO_CALENDAR_REMINDER_TRANSPORTATION:
                "add_todo_calendar_reminder_transportation",
            UPDATE_TODO_CALENDAR_REMINDER_TRANSPORTATION:
                "update_todo_calendar_reminder_transportation",
            DELETE_TODO_CALENDAR_REMINDER_TRANSPORTATION:
                "delete_todo_calendar_reminder_transportation"
        },
        CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION: {
            GET_LIST: "get_list",
            GET_CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION:
                "get_calendar_maintanance_config_transportation",
            UPDATE_PROVIDERS_TODOLIST: "update_providers_todolist",
            UPDATE_CALENDAR_MAINTANANCE_CONFIG_TRANSPORTATION:
                "update_calendar_maintanance_config_transportation",
            CHECK_EXISTED_CALENDAR_MAINTANANCE_CONFIG:
                "check_existed_calendar_maintanance_config",
            GET_KM_BEGIN_END: "get_km_begin_end",
            SET_KM_BEGIN_END: "set_km_begin_end"
        },
        CALENDAR_REMINDER_CONFIG_TRANSPORTATION: {
            GET_REMINDER_DOCUMENT_CONFIG: "get_reminder_document_config",
            PUT_REMINDER_DOCUMENT_CONFIG: "put_reminder_document_config",
            GET_REMINDER_MAINTANANCE_CONFIG: "get_reminder_maintanance_config",
            PUT_REMINDER_MAINTANANCE_CONFIG: "put_reminder_maintanance_config"
        },
        TODO_LIST: {
            GET_TODO_LIST: "get_todo_list",
            GET_TODO_LIST_BY_ID: "get_todo_list_by_id",
            POST_TODO_LIST: "post_todo_list",
            PUT_TODO_LIST: "put_todo_list",
            DELETE_TODO_LIST: "delete_todo_list"
        },
        DANH_MUC_BAO_DUONG: {
            GET_DANH_MUC_BAO_DUONG_LIST: "get_danh_muc_bao_duong_list",
            GET_DANH_MUC_BAO_DUONG_LIST_BY_ID:
                "get_danh_muc_bao_duong_list_by_id",
            POST_DANH_MUC_BAO_DUONG_LIST: "post_danh_muc_bao_duong_list",
            PUT_DANH_MUC_BAO_DUONG_LIST: "put_danh_muc_bao_duong_list",
            DELETE_DANH_MUC_BAO_DUONG_LIST: "delete_danh_muc_bao_duong_list"
        },
        DANH_SACH_TRUNG_TAM_DANG_KIEM: {
            GET_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST:
                "get_danh_sach_trung_tam_dang_kiem_list",
            GET_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST_BY_ID:
                "get_danh_sach_trung_tam_dang_kiem_list_by_id",
            POST_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST:
                "post_danh_sach_trung_tam_dang_kiem_list",
            PUT_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST:
                "put_danh_sach_trung_tam_dang_kiem_list",
            DELETE_DANH_SACH_TRUNG_TAM_DANG_KIEM_LIST:
                "delete_danh_sach_trung_tam_dang_kiem_list"
        },
        DANH_SACH_NHA_CUNG_CAP_BAO_HIEM: {
            GET_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST:
                "get_danh_sach_nha_cung_cap_bao_hiem_list",
            GET_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST_BY_ID:
                "get_danh_sach_nha_cung_cap_bao_hiem_list_by_id",
            POST_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST:
                "post_danh_sach_nha_cung_cap_bao_hiem_list",
            PUT_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST:
                "put_danh_sach_nha_cung_cap_bao_hiem_list",
            DELETE_DANH_SACH_NHA_CUNG_CAP_BAO_HIEM_LIST:
                "delete_danh_sach_nha_cung_cap_bao_hiem_list"
        },
        DANH_SACH_NHA_CUNG_CAP_PHU_HIEU: {
            GET_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST:
                "get_danh_sach_nha_cung_cap_phu_hieu_list",
            GET_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST_BY_ID:
                "get_danh_sach_nha_cung_cap_phu_hieu_list_by_id",
            POST_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST:
                "post_danh_sach_nha_cung_cap_phu_hieu_list",
            PUT_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST:
                "put_danh_sach_nha_cung_cap_phu_hieu_list",
            DELETE_DANH_SACH_NHA_CUNG_CAP_PHU_HIEU_LIST:
                "delete_danh_sach_nha_cung_cap_phu_hieu_list"
        },
        DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE: {
            GET_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST:
                "get_danh_sach_nha_cung_cap_dang_ky_xe_list",
            GET_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST_BY_ID:
                "get_danh_sach_nha_cung_cap_dang_ky_xe_list_by_id",
            POST_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST:
                "post_danh_sach_nha_cung_cap_dang_ky_xe_list",
            PUT_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST:
                "put_danh_sach_nha_cung_cap_dang_ky_xe_list",
            DELETE_DANH_SACH_NHA_CUNG_CAP_DANG_KY_XE_LIST:
                "delete_danh_sach_nha_cung_cap_dang_ky_xe_list"
        },
        DRIVERS_TRANSPORTATION: {
            GET_DANH_SACH_TAI_XE_LIST: "get_danh_sach_tai_xe_list",
            GET_DANH_SACH_TAI_XE_LIST_BY_ID: "get_danh_sach_tai_xe_list_by_id",
            POST_DANH_SACH_TAI_XE_LIST: "post_danh_sach_tai_xe_list",
            PUT_DANH_SACH_TAI_XE_LIST: "put_danh_sach_tai_xe_list",
            DELETE_DANH_SACH_TAI_XE_LIST: "delete_danh_sach_tai_xe_list"
        },
        MENU: {
            UPDATE_MENU_LIST: "update_menu_list",
            UPDATE_FORM_LIST: "update_form_list"
        },
        FORM_LIST: {
            GET_FORM_LIST: "get_form_list",
            GET_FORM_LIST_BY_ID: "get_form_list_by_id",
            POST_FORM_LIST: "post_form_list",
            PUT_FORM_LIST: "put_form_list",
            DELETE_FORM_LIST: "delete_form_list"
        },
        CALENDAR: {
            GET_ALL_CALENDAR_BY_TIME: "get_all_calendar_by_time",
            SET_ALL_CALENDAR_BY_TIME: "set_all_calendar_by_time"
        },
        PHU_TUNG: {
            GET_TYPE_PHU_TUNG: "phu_tung_get_type",
            GET_LIST_PHU_TUNG: "phu_tung_get_list",
            GET_LIST_PHU_TUNG_BY_ID: "phu_tung_get_list_by_id",
            POST_PHU_TUNG: "phu_tung_insert",
            PUT_PHU_TUNG: "phu_tung_update",
            DELETE_PHU_TUNG: "phu_tung_delete",
            SET_PHU_TUNG: "phu_tung_set",
            SET_TYPE_PHU_TUNG: "phu_tung_set_type",
            SEARCH_PHU_TUNG: "phu_tung_search"
        },
        TIRE: {
            GET_LIST_PHUONGTIEN: "tire_get_list_phuongtien",
            GET_LIST_PHUTUNG: "tire_get_list_phutung",
            POST_PT_TIRE: "tire_them_phutung",
            PUT_PT_TIRE: "tire_sua_phutung",
            DELETE_PT_TIRE: "tire_xoa_phutung",
            SET_LIST_PHUONGTIEN: "tire_set_list_phuongtien",
            SET_LIST_PHUTUNG: "tire_set_list_phutung",
            SET_LIST_BYTIME: "tire_set_list_bytime",
            SET_LIST_BYTIME_BYVEHICLE: "tire_set_list_bytime_byvehicle",
            SET_LIST_BYTIME_BYTIRE: "tire_set_list_bytime_bytire",
            SEARCH_BYTIME: "tire_search_bytime",
            GET_DETAIL_PHUONGTIEN: "tire_get_detail_phuongtien",
            SET_DETAIL_PHUONGTIEN: "tire_set_detail_phuongtien"
        },
        FUEL_CHANGE: {
            GET_VEHICLES_LIST: "fuel_change_get_vehicles_list",
            GET_FUEL_TYPE_LIST: "fuel_change_get_fuel_type_list",
            GET_LOCATION_LIST: "fuel_change_get_location_list",
            GET_DRIVER_LIST: "fuel_change_get_driver_list",
            SET_VEHICLES_LIST: "fuel_change_set_vehicles_list",
            SET_FUEL_TYPE_LIST: "fuel_change_set_fuel_type_list",
            SET_LOCATION_LIST: "fuel_change_set_location_list",
            SET_DRIVER_LIST: "fuel_change_set_driver_list",
            POST_SEARCH_ACTION: "fuel_change_post_search_action",
            UPDATE_FUEL_CHANGES_LIST: "fuel_change_update_fuel_changes_list",
            POST_INSERT_FUEL_CHANGE: "fuel_change_post_insert_fuel_change",
            SET_INSERT_FUEL_CHANGE_MESSAGE:
                "fuel_change_set_insert_fuel_change_message",
            POST_UPDATE_FUEL_CHANGE: "fuel_change_post_update_fuel_change",
            SET_UPDATE_FUEL_CHANGE_MESSAGE:
                "fuel_change_set_update_fuel_change_message",
            GET_DELETE_FUEL_CHANGE: "fuel_change_get_delete_fuel_change",
            SET_DELETE_FUEL_CHANGE_MESSAGE:
                "fuel_change_set_delete_fuel_change_message",
            GET_VIEW_DETAIL_ACTION: "fuel_change_get_view_detail_action",
            SET_VIEW_DETAIL_ACTION: "fuel_change_set_view_detail_action",
            POST_UPLOAD_TMP_FILE_FUEL: "fuel_change_post_upload_tmp_file_fuel"
        },
        NORM_CONFIGURATION: {
            SET_VEHICLE_LIST: "norm_configuration_set_vehicle_list",
            SET_VEHICLE_GROUPS: "norm_configuration_set_vehicle_groups",
            SET_VEHICLE_SETTINGS: "norm_configuration_set_vehicle_settings",
            SET_SAVE_ACTION: "norm_configuration_set_save_action",
            SET_DELETE_ACTION: "norm_configuration_set_delete_action",
            POST_VEHICLE_LIST: "norm_configuration_post_vehicle_list",
            GET_VEHICLE_GROUPS: "norm_configuration_get_vehicle_groups",
            GET_VEHICLE_SETTINGS: "norm_configuration_get_vehicle_settings",
            POST_SAVE_ACTION: "norm_configuration_post_save_action",
            GET_DELETE_ACTION: "norm_configuration_get_delete_action"
        },
        FUEL_CHANGE_REPORT: {
            SET_VEHICLE_LIST: "fuel_change_report_set_vehicle_list",
            SET_REPORT_DATA_ACTION: "fuel_change_report_set_report_data_action",
            SET_DOWNLOAD_REPORT_ACTION:
                "fuel_change_report_set_download_report_action",
            POST_VEHICLE_LIST: "fuel_change_report_post_vehicle_list",
            POST_REPORT_DATA_ACTION:
                "fuel_change_report_post_report_data_action",
            POST_DOWNLOAD_REPORT_ACTION:
                "fuel_change_report_post_download_report_action"
        },
        GENERAL_FUEL_REPORT: {
            SET_VEHICLE_GROUPS: "general_fuel_report_set_vehicle_groups",
            SET_VEHICLES_BY_GROUP: "general_fuel_report_set_vehicles_by_group",
            SET_REPORT_EXTEND_DATA_ACTION: "general_fuel_report_set_report_extend_data_action",
            SET_DOWNLOAD_EXTEND_REPORT_ACTION: "general_fuel_report_set_download_extend_report_action",
            GET_VEHICLE_GROUPS: "general_fuel_report_get_vehicle_groups",
            POST_VEHICLES_BY_GROUP: "general_fuel_report_post_vehicles_by_group",
            POST_REPORT_EXTEND_DATA_ACTION: "general_fuel_report_post_report_extend_data_action",
            POST_DOWNLOAD_EXTEND_REPORT_ACTION: "general_fuel_report_post_download_extend_report_action"
        },
        MAINTAINANCE_REPORT: {
            SET_VEHICLE_LIST: "maintainance_report_set_vehicle_list",
            SET_MAINTAINANCE_WORKS: "maintainance_report_set_maintainance_works",
            SET_VENDOR_SUPPLIES: "maintainance_report_set_vendor_supplies",
            SET_REPORT_DATA_ACTION: "maintainance_report_set_report_data_action",
            SET_DOWNLOAD_REPORT_ACTION: "maintainance_report_set_download_report_action",
            POST_VEHICLE_LIST: "maintainance_report_post_vehicle_list",
            GET_MAINTAINANCE_WORKS: "maintainance_report_get_maintainance_works",
            GET_VENDOR_SUPPLIES: "maintainance_report_get_vendor_supplies",
            POST_REPORT_DATA_ACTION: "maintainance_report_post_report_data_action",
            POST_DOWNLOAD_REPORT_ACTION: "maintainance_report_post_download_report_action"
        }
    },
    FUNCTION: {
        COMMON: {
            /**
             * @description: **Ẩn menu khi chọn ở giao diện mobile**
             * @param  id:  string
             * @return void  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 00:48:55 2019-05-12
             */
            isMobile: (id) => {
                if ($(window).width() < 993) {
                    setTimeout(() => {
                        $(id).removeClass("show")
                    }, 150)
                }
            },

            /**
             * @description: **Hàm ghi logs client**
             * Hàm được kích hoạt với const powerWriteLog ở CONSTANTS
             * @param  message:  string type
             * @return void  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 21:29:02 2019-05-05
             */
            createLog: (message) => {
                // Trường hợp không ghi logs
                if (!powerWriteLog) return
                // Trường hợp ghi logs
                // Ghi logs
                console.log(
                    `%c alogobay say: ${moment().format(
                        CONSTANTS.FULL_DATE_FORMAT
                    )}`,
                    "background: #ffffff; color: #f00"
                )
                console.log(
                    `%c \t\t\t\t Logs: ${JSON.stringify(message)}`,
                    "background: #ffffff; color: #018ea5"
                )
            },
            /**
             * @description: **Hàm kiểm tra trình duyệt có hổ trợ storage**
             * @param  func:  function call command for storage
             * @return return type (void, boolean, int, string, object, array,...)  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 21:11:44 2019-06-28
             */
            storage: (func) => {
                // Kiểm tra trình duyệt có hỗ trợ hay không
                if (typeof Storage !== "undefined") {
                    // // Khởi tạo sesionStorage
                    // sessionStorage.setItem('name', 'Ted Mosby');
                    // // get sessionStorage
                    // sessionStorage.getItem('name');
                    // // lấy ra số lượng session đã lưu trữ
                    // sessionStorage.length;
                    // // xóa 1 item localStorage
                    // sessionStorage.removeItem('name');
                    // // xóa tất cả item trong sessionStorage
                    // sessionStorage.clear();

                    // Lưu token vào session (token được mã hoá bằng privateKeyServer => trên server sẽ đọc được)
                    return func()
                } else {
                    // Ghi log thông báo cho client
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `Current browser is not support, please upgrade it `
                    )
                    return null
                }
            },
            /**
             * @description: **Clear storage**
             * @param  storage:  object of storage
             * @return void  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 08:30:01 2019-09-21
             */
            clearStorage: (storage) => {
                storage.clear()
                CONSTANTS.FUNCTION.COMMON.createLog(`Clear session successful`)
            },
            localStorage: {
                /**
                 * @description: **Set localStorage**
                 * @param  key:  string
                 * @param  value:  any
                 * @return object local storage
                 * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 21:13:24 2019-06-28
                 */
                set: (key, value) =>
                    CONSTANTS.FUNCTION.COMMON.storage(
                        () => (localStorage[key] = value)
                    ),
                /**
                 * @description: **Get localStorage**
                 * @param key: string
                 * @return any
                 * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 21:14:23 2019-06-28
                 */
                get: (key) =>
                    CONSTANTS.FUNCTION.COMMON.storage(() => localStorage[key]),

                /**
                 * @description: **Clear localStorage **
                 * @param  param:  param type
                 * @return return type (void, boolean, int, string, object, array,...)  and write logs
                 * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 08:34:49 2019-09-21
                 */
                clear: () => {
                    CONSTANTS.FUNCTION.COMMON.clearStorage(localStorage)
                }
            },

            sesionStorage: {
                /**
                 * @description: **Set sessionStorage**
                 * @param  key:  string
                 * @param  value:  any
                 * @return any
                 * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 21:16:19 2019-06-28
                 */
                set: (key, value) =>
                    CONSTANTS.FUNCTION.COMMON.storage(
                        () => (sessionStorage[key] = value)
                    ),
                /**
                 * @description: **Get sessionStorage**
                 * @param key: string
                 * @return return type (void, boolean, int, string, object, array,...)  and write logs
                 * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 21:17:01 2019-06-28
                 */
                get: (key) =>
                    CONSTANTS.FUNCTION.COMMON.storage(
                        () => sessionStorage[key]
                    ),
                /**
                 * @description: **Clear sesionStorage **
                 * @param  param:  param type
                 * @return return type (void, boolean, int, string, object, array,...)  and write logs
                 * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 08:34:49 2019-09-21
                 */
                clear: () => {
                    CONSTANTS.FUNCTION.COMMON.clearStorage(sesionStorage)
                }
            },

            cookieStorage: {
                /**
                 * @description: **Get cookie authst**
                 * Nếu không có sẽ reload lại trang để xin cookie authst
                 * @return string jwt token  and write logs
                 * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 21:18:19 2019-06-28
                 */
                AUTHST: () => {
                    const authst = Cookies.get("authst")
                    if (typeof authst === "undefined") {
                        toast(translate.t("common.delete_cookies"), "error")
                        // redirect lại trang sau 2 giây
                        setTimeout(() => {
                            window.location.href = "/"
                        }, 2000)
                    } else {
                        return authst
                    }
                },

                /**
                 * @description: **Set cookie**
                 * @param name: string
                 * @param value: any
                 * @param expires: expires days
                 * @return return type (void, boolean, int, string, object, array,...)  and write logs
                 * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 21:19:28 2019-06-28
                 */
                set: (name, value, expires = 30) => {
                    Cookies.set(name, value, { expires: expires })
                },

                /**
                 * @description: **Get cookie**
                 * @param name: string
                 * @return any  and write logs
                 * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 21:20:36 2019-06-28
                 */
                get: (name) => Cookies.get(name),

                /**
                 * @description: **Remove cookie**
                 * @param name: string
                 * @return void
                 * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 21:21:08 2019-06-28
                 */
                remove: (name) => {
                    Cookies.remove(name)
                }
            },

            /**
             * @description: **Set giá trị cho token session**
             * @param  token:  string
             * @return void
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 22:33:33 2019-05-05
             */
            updateTokenStorage: (token) => {
                CONSTANTS.FUNCTION.COMMON.storage(() => {
                    CONSTANTS.FUNCTION.COMMON.localStorage.set("token", token)
                })
            },

            /**
             * @description: **Xoá session trình duyệt**
             * @return void and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 22:31:37 2019-05-05
             */
            clearTokenStorage: () => {
                CONSTANTS.FUNCTION.COMMON.storage(() => {
                    // sessionStorage.removeItem('token')
                    CONSTANTS.FUNCTION.COMMON.localStorage.clear()
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `Clear token and localStoreage successful`
                    )
                })
            },

            /**
             * @description: **Set slim scrollbar**
             * @param className: .classname of string (required)
             * @param height : string (required)
             * @param time: number
             * @return void  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 14:29:27 2019-03-28
             */
            slimScrollBar: (className, height, time) => {
                setTimeout(() => {
                    if ($(className).length) {
                        $(className)
                            .slimScroll({
                                height: height,
                                opacity: 0
                            })
                            .mouseover(function () {
                                $(this)
                                    .next(".slimScrollBar")
                                    .css("opacity", 0.2)
                            })
                    }
                }, time)
            },

            /**
             * @description: **Ẩn/Hiện menu dashboard theo trang thái của state isShowDashBroad**
             * Thay đổi css của class dashboard-wrapper
             * @param  isShowDashBroad:  boolean
             * @return void
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 12:12:58 2019-03-23
             */
            isShowDashBoard: (isShowDashBoard) => {
                if (isShowDashBoard) {
                    $(".dashboard-wrapper").css("margin-left", "260px")
                } else {
                    $(".dashboard-wrapper").css("margin-left", "0px")
                }
            },

            /**
             * @description: **Ẩn/Hiện margin right message**
             * @param isShowMessage: boolean
             * @return void
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 20:52:15 2019-05-02
             */
            isShowMessage: (isShowMessage) => {
                isShowMessage
                    ? $(".dashboard-wrapper").css("margin-right", "260px")
                    : $(".dashboard-wrapper").css("margin-right", "0px")

                // $('.nav-right-sidebar sidebar').css('display', 'block')
                // $('.nav-right-sidebar sidebar').css('display', 'none')
            },
            /**
             * @description: **Hàm thay đổi ngôn ngữ dựa vào ngôn ngữ hiện tại**
             * @param currentLanguage: string
             * @return void  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 07:00:38 2019-03-25
             */
            changeLanguage: (currentLanguage) => {
                if (currentLanguage) {
                    translate.changeLanguage("en")
                } else {
                    translate.changeLanguage("vi")
                }
            },
            /**
             * @description: **Xoá 1 phần tử của mảng chứa dir hình ảnh**
             * @param  array:  array
             * @param  removeIndex:  int index remove element
             * @param  defaultImage:  string directory of element photo
             * @return array/false  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 23:55:28 2019-07-12
             */
            removeElementArray: (array, removeIndex, defaultImage) => {
                if (Array.isArray(array) && array.length > 0) {
                    // Xoá 1 phần tử trong mảng có index=values.imageIndexDelete từ client gửi lên
                    array.splice(removeIndex, 1)
                    if (array.length === 0) array.push(defaultImage)
                    return array
                } else return false
            },
            /**
             * @description: **Hàm hiển thị thời gian theo ngôn ngữ hiện hành**
             * @param time: formart "DD-MM-YYYY, HH:mm:ss"
             * @return string
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 16:04:32 2019-08-31
             */
            getLastTimeUpdate: (time) => {
                moment.locale(translate.language)

                if (typeof time === "undefined")
                    time = moment().format(CONSTANTS.DATE_FORMAT)

                const formartTime = moment(time, CONSTANTS.DATE_FORMAT)
                return formartTime.startOf("minutes").fromNow()

                // const getTimeUpdatePost = moment().diff(updateDatePost, 'days')
                // return moment.duration(getTimeUpdatePost, "days").humanize()
            },
            /**
             * @description: **Format date by system format**
             * @param  date:  string date
             * @return return type (void, boolean, int, string, object, array,...)  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 23:58:00 2019-09-27
             */
            formatDate: (date = new Date(), formart) => {
                if (!formart) formart = CONSTANTS.SHORT_DATE_FORMAT
                if (moment(date, formart, true))
                    return moment(date).format(formart)
                else return translate.t("error_formart_date_time")
            },
            formatFromDateForCalendar: (date = new Date(), formart) => {
                if (!formart) formart = CONSTANTS.SHORT_DATE_FORMAT
                if (moment(date, formart, true))
                    return moment(date).subtract(200, "days").format(formart)
                else return translate.t("error_formart_date_time")
            },
            formatToDateForCalendar: (date = new Date(), formart) => {
                if (!formart) formart = CONSTANTS.SHORT_DATE_FORMAT
                if (moment(date, formart, true))
                    return moment(date).subtract(1, "days").format(formart)
                else return translate.t("error_formart_date_time")
            },

            /**
             * @description: **Hàm kiểm tra object có phải Date không**
             * @param  value:  object
             * @return true | false
             * @author:  Tô Đại Thịnh 09:50:00 2023-06-23
             */
            isDate: (value) => {
                return value instanceof Date && !isNaN(value)
            },

            /**
             * @description: **Hàm chuyển từ Date sang string dạng dd/mm/yyyy**
             * @param  value:  object
             * @return string
             * @author:  Tô Đại Thịnh 09:45:58 2023-06-23
             */
            convertDateToStringCommonFormat: (value, format) => {
                switch (format) {
                    case "dd/MM/yyyy hh:mm":
                        return CONSTANTS.FUNCTION.COMMON.isDate(value)
                            ? `${value.toLocaleDateString("vi-VN", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric"
                              })} ${value.toLocaleTimeString("vi-VN", {
                                  hour: "2-digit",
                                  minute: "2-digit"
                              })}`
                            : "Không phải là object của Date"
                    case "dd/MM/yyyy hh:mm:00":
                        return CONSTANTS.FUNCTION.COMMON.isDate(value)
                            ? `${value.toLocaleDateString("vi-VN", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric"
                              })} ${value.toLocaleTimeString("vi-VN", {
                                  hour: "2-digit",
                                  minute: "2-digit"
                              })}:00`
                            : "Không phải là object của Date"
                    default:
                        return CONSTANTS.FUNCTION.COMMON.isDate(value)
                            ? value.toLocaleDateString("vi-VN", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric"
                              })
                            : "Không phải là object của Date"
                }
            },

            /**
             * @description: **Hàm trừ 2 ngày**
             * @param  firstDate:   string for firstDate
             * @param  endDate:  string for endDate
             * @return string
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 17:38:19 2019-09-27
             */
            subtractDate: (firstDate, endDate) =>
                moment(endDate).diff(moment(firstDate), "days"),
            addHoursToDate: (date, hours) => moment(date).add(hours, "h"),
            /**
             * @description: **Hàm tính toán ngày hết hạn**
             * @param  firstDate:   string for firstDate
             * @param  endDate:  string for endDate
             * @return number/false
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 11:55:09 2019-09-30
             */
            isExpiredDate: (firstDate, endDate) => {
                const tmp = moment(endDate).diff(moment(firstDate), "days")
                if (tmp >= 0) return tmp
                else return false
            },
            /**
             * @description: **Hàm format giá trị về kiểu tiền tệ**
             * @param value: value of currency
             * @param code: object location
             * @return string
             * @author:  alogobay 15:34:54 2019-11-01
             */
            currencyFormatter: (value, locale) =>
                currencyFormatter.format(parseInt(value), locale),
            change_alias: (alias) => {
                let str = alias
                str = str.toLowerCase()
                str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a")
                str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e")
                str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i")
                str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o")
                str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u")
                str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y")
                str = str.replace(/đ/g, "d")
                str = str.replace(
                    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
                    " "
                )
                str = str.replace(/ + /g, " ")
                str = str.trim()
                return str
            }
        },
        PRIVATE: {
            /**
             * @description: **Hàm mã hoá dữ liệu bằng client key**
             * @param  data: object
             * @return string  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 17:22:56 2019-06-14
             */
            encodedByClientKey: (data, time = "10 days") => {
                try {
                    if (CONSTANTS.KEY.flagAuth) {
                        // Mã hoá account bằng khoá đọc dữ liệu từ client
                        return jwt.sign(
                            data,
                            CONSTANTS.KEY.private_key_client,
                            {
                                expiresIn: time
                            }
                        )
                    } else {
                        return data
                    }
                } catch (error) {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 415, Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return null
                }
            },

            /**
             * @description: **Hàm giải mã dữ liệu bằng client key**
             * @param  data: object
             * @return string  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 17:23:56 2019-06-14
             */
            decodedByClientKey: (data) => {
                try {
                    if (CONSTANTS.KEY.flagAuth) {
                        return jwt.verify(
                            data,
                            CONSTANTS.KEY.private_key_client
                        )
                    } else {
                        return data
                    }
                } catch (error) {
                    // Ghi log thông báo cho client
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 357, Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return "undefined"
                }
            },

            /**
             * @description: **Hàm mã hoá dữ liệu bằng cookie authst**
             * @param data: object
             * @return string  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 17:19:10 2019-06-14
             */
            encodedAuthSt: (data, time = "1h") => {
                try {
                    if (CONSTANTS.KEY.flagAuth) {
                        // Mã hoá account bằng khoá đọc dữ liệu từ client
                        return jwt.sign(
                            data,
                            CONSTANTS.FUNCTION.PRIVATE.createSecretStKey(
                                CONSTANTS.FUNCTION.COMMON.cookieStorage.AUTHST()
                            ),
                            {
                                expiresIn: time
                            }
                        )
                    } else {
                        return data
                    }
                } catch (error) {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 450, Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return null
                }
            },

            /**
             * @description: **Hàm giải mã dữ liệu bằng cookie authst**
             * @param  data: object
             * @return string  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 17:20:09 2019-06-14
             */
            decodedAuthSt: (data) => {
                try {
                    if (CONSTANTS.KEY.flagAuth) {
                        return jwt.verify(
                            data,
                            CONSTANTS.FUNCTION.PRIVATE.createSecretStKey(
                                CONSTANTS.FUNCTION.COMMON.cookieStorage.AUTHST()
                            )
                        )
                    } else {
                        return data
                    }
                } catch (error) {
                    // Ghi log thông báo cho client
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 474, Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return "undefined"
                }
            },

            /**
             * @description: **Hàm mã hoá dữ liệu bằng khoá đọc dữ liệu authnd**
             * @param  data: object
             * @return string  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 17:21:07 2019-06-14
             */
            encodedAuthNd: (data, time = "1h") => {
                try {
                    if (CONSTANTS.KEY.flagAuth) {
                        // Mã hoá account bằng khoá đọc dữ liệu từ client
                        return jwt.sign(
                            data,
                            CONSTANTS.FUNCTION.PRIVATE.createSecretNdKey(
                                CONSTANTS.FUNCTION.COMMON.cookieStorage.AUTHST()
                            ),
                            {
                                expiresIn: time
                            }
                        )
                    } else {
                        return data
                    }
                } catch (error) {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 486, Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return null
                }
            },

            /**
             * @description: **Hàm giải mã dữ liệu bằng khoá đọc dữ liệu authnd**
             * @param  data: object
             * @return string  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 17:22:14 2019-06-14
             */
            decodedAuthNd: (data) => {
                try {
                    if (CONSTANTS.KEY.flagAuth) {
                        return jwt.verify(
                            data,
                            CONSTANTS.FUNCTION.PRIVATE.createSecretNdKey(
                                CONSTANTS.FUNCTION.COMMON.cookieStorage.AUTHST()
                            )
                        )
                    } else {
                        return data
                    }
                } catch (error) {
                    // Ghi log thông báo cho client
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 504, Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return "undefined"
                }
            },

            /**
             * @description: **Hàm tạo key cho các tài khoản đăng nhập từ facebook hoặc goole hoặc authst**
             * @param id: string
             * @return string
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 15:18:56 2019-05-20
             */
            createSecretStKey: (str) => {
                try {
                    return btoa(btoa(`alo${str}gobay`).substr(-7, 16)).replace(
                        /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g,
                        ""
                    )
                } catch (error) {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 519, Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return null
                }
            },

            /**
             * @description: **Hàm tạo khoá đọc dữ liệu authnd**
             * @param  str:  string
             * @return string and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 17:24:53 2019-06-14
             */
            createSecretNdKey: (str) => {
                try {
                    return btoa(btoa(`alo${str}gobay`).substr(7, 16)).replace(
                        /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g,
                        ""
                    )
                } catch (error) {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 534, Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return null
                }
            },

            /**
             * @description: **Hàm tìm document có quan hệ**
             * @param  id:  mongoId string
             * @param  modelName:  string of model mongoose
             * @param  docunemts:  array of document in mongo database
             * @return null/object  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 17:39:01 2019-06-26
             */
            getDocumentsRelationship: (parentId, modelName, documents) => {
                for (const document of documents) {
                    return document.values.rs.filter((item) => {
                        const _id = item.key.split("-")[0]
                        const _modelName = item.key.split("-")[1]
                        return parentId === _id && modelName === _modelName
                    })
                }
            },
            /**
             * @description: **Hàm tìm _id của parent document trong child document (nếu có quan hệ)**
             * @param document: object child document
             * @param modelName: string is model name of parent document
             * @return string or null  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 16:55:42 2019-09-01
             */
            getIdDocumentInRelationship: (document, modelName) => {
                let _id = null
                if (Array.isArray(document.values.rs)) {
                    for (const rs of document.values.rs) {
                        // TODO: Trường hợp trong mảng rs có tồn tại nhiều hơn 2 phần tử có cũng modelName thì phải xử lý ntn ?
                        if (rs.key.split("-")[1] === modelName) {
                            _id = rs.key.split("-")[0]
                            break
                        }
                    }
                } else {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 685, Error :rs in document is not array, look: ${JSON.stringify(
                            document
                        )}`
                    )
                }

                return _id
            },
            /**
             * @description: **Hàm kiểm tra quan hệ của 2 document**
             * @param  id:  mongoId string
             * @param  modelName:  string of model mongoose
             * @param  docunemts:  array of document in mongo database
             * @return boolean  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 17:39:01 2019-06-26
             */
            checkDocumentRelationship: (id, modelName, document) => {
                let result = false
                document.values.rs.forEach((item) => {
                    const _id = item.key.split("-")[0]
                    const _modelName = item.key.split("-")[1]
                    if (id === _id && modelName === _modelName) {
                        result = true
                    }
                })
                return result
            },
            /**
             * @description: **Hàm cập nhật các src image từ blob sang real path from server**
             * Hàm chỉ sử dụng cho việc cập nhật hình ảnh blob của editor sang real path từ server
             * pathName được gán cố định => có điều chỉnh thì ở đây
             * regex được gán cố định => có điều chỉnh thì ở đây
             * @param  editor:  editor object
             * @return return type (void, boolean, int, string, object, array,...)  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 16:51:36 2019-08-08
             */
            updateBlobImageToRealPath: (editor) => {
                if (Array.isArray(editor.files)) {
                    editor.files.forEach((file) => {
                        const pathName = `public/uploads/images/posts/${editor._id.replace(
                            "-comment",
                            ""
                        )}/${file[0].newName}.${
                            file[0].name.split(".")[
                                file[0].name.split(".").length - 1
                            ]
                        }`
                        const regex = `blob:https://localhost:8001/${file[0].newName}`
                        const contents = editor.contents.replace(
                            regex,
                            pathName
                        )
                        editor.contents = contents
                    })
                }
                return editor
            }
        },
        REDUX: {
            /**
             * @description: **Hàm trả về đối tượng cho dispatch redux-observarble**
             * @param  type:  type of action object
             * @param  payload:  payload of action object (Lưu ý tên tham số payload này phải trùng với tham số ở reducer)
             * @return return object
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 12:13:06 2019-03-21
             */
            DISPATCH: (type, payload) => ({
                type: type,
                payload
            }),

            /**
             * @description: **Hàm chuyển đổi actions thành các đối tượng truyền vào hàm connect redux**
             * @param  dispatch:  tham số dispatch được truyền từ function MapDispatchToProps gốc (?map snippet)
             * @param  actionObject:  object chứa các đối tượng action trả về
             * @return return object
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 17:04:54 2019-06-25
             */
            MapDispatchToProps: (dispatch, actionObject) => ({
                dispatch,
                ...bindActionCreators(actionObject, dispatch)
            }),

            NONE: () => ({
                type: CONSTANTS.ACTION.SYSTEM.NONE
            }),

            /**
             * @description: **Hàm trả về đối tượng action chứa lỗi cho hàm dispatch**
             * @param  error:  Nội dung lỗi
             * @param  code:  Mã lỗi do người dùng tự định nghĩa hoặc gọi trong CONSTANTS
             * @return object
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 12:07:23 2019-03-21
             */
            ERROR: (error) => ({
                type: CONSTANTS.ACTION.SYSTEM.STATUS,
                payload: { status: CONSTANTS.ACTION.SYSTEM.ERROR, data: error }
            })
        },
        AXIOS: {
            BEARER_TOKEN: (obj) => {
                const token =
                    CONSTANTS.FUNCTION.COMMON.localStorage.get("token")
                // Kiểm tra sự tồn tại của token ở localStorage
                if (typeof token === "undefined")
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 743, Error : token is not existed, please check function post token api at LoginController.js`
                    )
                // trả về object header
                if (obj)
                    return {
                        ...obj,
                        Authorization: `bearer ${token}`
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                        // 'content-type': 'application/x-www-form-urlencoded',
                        // 'content-type': 'multipart/form-data'
                    }
                else
                    return {
                        Authorization: `bearer ${token}`
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                        // 'content-type': 'application/x-www-form-urlencoded',
                        // 'content-type': 'multipart/form-data'
                    }
            },
            /**
             * @description: **Hàm chuyển đổi object params to FormData**
             * @param  param:  object
             * @return return type (void, boolean, int, string, object, array,...)  and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 15:57:04 2019-09-20
             */
            ENCODE_FORM_DATA: (params) => {
                try {
                    return Object.keys(params)
                        .map(
                            (key) =>
                                `${encodeURIComponent(
                                    key
                                )}=${encodeURIComponent(params[key])}`
                        )
                        .join("&")
                } catch (error) {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 715, Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return null
                }
            },
            /**
             * @description: **Hàm get dữ liệu của axios**
             * @param url: string url
             * @param params: object chứa các giá trị từ client gửi lên
             * @return promise and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 15:24:08 2019-05-20
             */
            GET: async (url, params) => {
                try {
                    let result = null
                    if (typeof params === "undefined") {
                        result = await axios.get(CONSTANTS.API_HOST + url, {
                            headers: CONSTANTS.FUNCTION.AXIOS.BEARER_TOKEN()
                        })
                    } else
                        result = await axios.get(CONSTANTS.API_HOST + url, {
                            headers: CONSTANTS.FUNCTION.AXIOS.BEARER_TOKEN(),
                            params: {
                                ...params
                            }
                        })

                    if (typeof result.data === "string") {
                        result.data = JSON.parse(result.data.trim())
                    }
                    return result
                } catch (error) {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 1198. Call api [${url}]  Error: ${JSON.stringify(
                            error
                        )}`
                    )
                    return null
                }
            },
            DOWNLOAD_FILE: async (url, params) => {
                try {
                    const result = await axios.get(CONSTANTS.API_HOST + url, {
                        headers: CONSTANTS.FUNCTION.AXIOS.BEARER_TOKEN(),
                        responseType: "arraybuffer",
                        params: {
                            ...params
                        }
                    })
                    // if (typeof result.data === "string") {
                    //    result.data = JSON.parse(result.data.trim())
                    // }
                    return result
                } catch (error) {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 747, Call api [${url}] Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return null
                }
            },

            /**
             * @description: **Hàm post download file của axios**
             * @param url: string url
             * @param params: các tham số được truyền vào cho việc truy vấn
             * @return promise and write logs
             */
            POST_DOWNLOAD_FILE: async (url, params) => {
                try {
                    const result = await axios.post(
                        CONSTANTS.API_HOST + url,
                        CONSTANTS.FUNCTION.AXIOS.ENCODE_FORM_DATA(params),
                        {
                            headers: CONSTANTS.FUNCTION.AXIOS.BEARER_TOKEN(),
                            responseType: "blob"
                        }
                    )

                    return result
                } catch (error) {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 747, Call api [${url}] Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return null
                }
            },

            /**
             * @description: **Hàm post dữ liệu của axios**
             * @param url: string url
             * @param params: object chứa các giá trị từ client gửi lên, các giá trị này được mã hoá bởi client key
             * @return promise and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 15:24:08 2019-05-20
             */
            POST: async (url, params) => {
                try {
                    const result = await axios.post(
                        CONSTANTS.API_HOST + url,
                        CONSTANTS.FUNCTION.AXIOS.ENCODE_FORM_DATA(params),
                        {
                            headers: CONSTANTS.FUNCTION.AXIOS.BEARER_TOKEN()
                        }
                    )
                    if (typeof result.data === "string") {
                        result.data = JSON.parse(result.data.trim())
                    }
                    return result
                } catch (error) {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 747, Call api [${url}] Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return null
                }
            },
            POST_IMAGE: async (url, fileName, file) => {
                const formData = new FormData()
                formData.append(fileName, file)
                const config = {
                    headers: CONSTANTS.FUNCTION.AXIOS.BEARER_TOKEN()
                }
                try {
                    const result = await axios.post(
                        CONSTANTS.API_HOST + url,
                        formData,
                        config
                    )
                    if (typeof result.data === "string") {
                        result.data = JSON.parse(result.data.trim())
                    }
                    return result
                } catch (error) {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file: Constants ---Line: 747, Call api [${url}] Error : ${JSON.stringify(
                            error
                        )}`
                    )
                    return null
                }
            },

            /**
             * @description: **Hàm put dữ liệu của axios**
             * @param url: string url
             * @param params: object chứa các giá trị từ client gửi lên, các giá trị này được mã hoá bởi khoá đọc dự liệu
             * @return promise and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 15:24:08 2019-05-20
             */
            PUT: async (url, params) => {
                const result = await axios.put(
                    CONSTANTS.API_HOST + url,
                    CONSTANTS.FUNCTION.AXIOS.ENCODE_FORM_DATA(params),
                    {
                        headers: CONSTANTS.FUNCTION.AXIOS.BEARER_TOKEN()
                    }
                )

                if (typeof result.data === "string") {
                    result.data = JSON.parse(result.data.trim())
                }
                return result
            },

            /**
             * @description: **Hàm delete dữ liệu của axios**
             * @param url: string url
             * @param params: object chứa các giá trị từ client gửi lên, các giá trị này được mã hoá bởi khoá đọc dự liệu
             * @return promise and write logs
             * @author:  Phan Phuơng Đạt 0949607608 - skype: alogobay -  email: alogobay@gmail.com 15:24:08 2019-05-20
             */
            // params:{_id:string mongoID}
            // Bắt buộc config gửi lên server phải là {data:{value}}
            DELETE: async (url, params) => {
                try {
                    const data = {
                        ...params,
                        data: CONSTANTS.FUNCTION.PRIVATE.encodedAuthNd(
                            params.data
                        )
                    }
                    const result = await axios.delete(url, {
                        data: {
                            params: CONSTANTS.FUNCTION.PRIVATE.encodedAuthSt(
                                data
                            )
                        }
                    })
                    if (typeof result.data === "string") {
                        result.data = JSON.parse(result.data.trim())
                    }
                    return result
                } catch (error) {
                    CONSTANTS.FUNCTION.COMMON.createLog(
                        `From file:  Constants.js ---Line: 491, Call api [${url}] ${JSON.stringify(
                            error
                        )}`
                    )
                    return null
                }
            },
            UPLOAD_IMAGE: async (files, pathUpload) => {
                // Getting the properties of file from file field
                const fileData = files[0]
                // Giới hạn dung lượng size
                if (fileData.size > CONSTANTS.KEY.limit_image_size) {
                    toast(
                        translate.t(
                            "components.baseComponent.modal.image.limit_size_image"
                        )
                    )
                    return null
                } else {
                    // Creating object of FormData class
                    const formData = new FormData()
                    // Appending parameter named file with properties of file_field to form_data
                    // Gửi lên server tên thư mục mong muốn tạo req.dirName='build/uploads/images/test' => Trên server chưa xử lý chức năng này
                    // Adding extra parameters to form_data
                    formData.append("path", path.join(__dirname, pathUpload))
                    if (typeof files[0].newName !== "undefined")
                        formData.append("name", files[0].newName)
                    formData.append("image", fileData)
                    const config = {
                        headers: {
                            "content-type": "multipart/form-data"
                        }
                    }
                    // Gọi api post data image lên server
                    const res = await axios.post(
                        CONSTANTS.URL.IMAGE.POST,
                        formData,
                        config
                    )
                    return res
                }
            },
            UPLOAD_FILE: async (url, files) => {
                // Getting the properties of file from file field
                const fileData = files[0]
                // Giới hạn dung lượng size
                if (fileData.size > CONSTANTS.KEY.limit_file_size) {
                    toast(
                        translate.t(
                            "components.baseComponent.modal.file.limit_size_file"
                        )
                    )
                    return null
                } else {
                    // Creating object of FormData class
                    const formData = new FormData()
                    // Appending parameter named file with properties of file_field to form_data
                    // Gửi lên server tên thư mục mong muốn tạo req.dirName='build/uploads/images/test' => Trên server chưa xử lý chức năng này
                    // Adding extra parameters to form_data
                    formData.append("file_excel", fileData)
                    const config = {
                        headers: {
                            ...CONSTANTS.FUNCTION.AXIOS.BEARER_TOKEN(),
                            "content-type": "multipart/form-data"
                        }
                    }
                    // Gọi api post data image lên server
                    const res = await axios.post(
                        CONSTANTS.API_HOST + url,
                        formData,
                        config
                    )
                    if (typeof res.data === "string") {
                        res.data = JSON.parse(res.data.trim())
                    }
                    return res
                }
            }
        }
    },
    DATA: {
        DEFAULT: {
            IMAGE_STORE: "public/assets/images/system/default.png",
            IMAGE_ACCOUNT: "public/assets/images/system/default_avatar.png"
        },
        // TODO: Copy async danh sách với language.js backend
        LANGUAGES: [
            { key: "vi-VN", value: "Tiếng Việt" },
            { key: "en-US", value: "English" }
        ]
    },
    REPORT: {
        DELETE_BY_ADMIN: "delete by admin",
        DELETE_BY_USER: "delete by user",
        USER_HAS_VIOLATED_RULES: "user has violated rules"
    }
}

export default CONSTANTS
